import { ImportProductComponent } from './import-product.component';

export default ImportProductComponent;
